// extracted by mini-css-extract-plugin
module.exports = {"textSize":"TermOfUse_textSize__inmeG"};